"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.array.join");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderBmExpansionPanelLayout = exports.registerBmExpansionPanelLayout = exports.defaultBmExpansionLayoutOpts = void 0;

var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _uiElements = require("@blue/ui-elements");

var _element = require("@blue/element");

var _layoutRegistry = require("../../registry/layout-registry");

var _validators = require("../../validators");

var _bmFormValues = require("../bm-form-values");

var _renderVariableLayout = require("./render-variable-layout");

var _renderLayout = require("./render-layout");

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-expansion-panel-layout .info=\"", "\" .items=\"", "\"></bm-expansion-panel-layout> "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-expansion-panel-add-button\n\t\t\t\t.addButtonLabel=\"", "\"\n\t\t\t\t@click=\"", "\"\n\t\t\t></bm-expansion-panel-add-button>\n\t\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-expansion-panel-remove-button\n\t\t\t\t.removeButtonLabel=\"", "\"\n\t\t\t\t@removeRow=\"", "\"\n\t\t\t></bm-expansion-panel-remove-button>\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-expansion-panel\n\t\t\t\tgroup=\"", "\"\n\t\t\t\t?expanded=\"", "\"\n\t\t\t\t?autoClose=\"", "\"\n\t\t\t\t?hideCaret=\"", "\"\n\t\t\t\t?disabled=\"", "\">\n\n\t\t\t\t<span slot=\"panel-title\">", "</span>\n\t\t\t\t<div slot=\"panel-content\">\n\t\t\t\t\t", "\n\t\t\t\t</div>\n\t\t\t\t<span slot=\"panel-header-actions\">\n\t\t\t\t\t", "\n\t\t\t\t</span>\n\t\t\t</bm-expansion-panel>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t\t", "\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t:host {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t:host bm-expansion-panel-add-button:not(:first-child) {\n\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t}\n\t\t\t\t:host bm-expansion-panel-remove-button {\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var defaultBmExpansionLayoutOpts = {
  autoClose: true,
  hideCaret: false,
  disablePanelToggle: false
};
exports.defaultBmExpansionLayoutOpts = defaultBmExpansionLayoutOpts;

var BmExpansionPanelLayout = /*#__PURE__*/function (_bmVariableLayout) {
  (0, _inherits2.default)(BmExpansionPanelLayout, _bmVariableLayout);

  var _super = (0, _createSuper2.default)(BmExpansionPanelLayout);

  (0, _createClass2.default)(BmExpansionPanelLayout, null, [{
    key: "is",
    get: function get() {
      return 'bm-expansion-panel-layout';
    }
  }, {
    key: "styles",
    get: function get() {
      return [(0, _element.css)(_templateObject())];
    }
  }]);

  function BmExpansionPanelLayout() {
    var _this;

    (0, _classCallCheck2.default)(this, BmExpansionPanelLayout);
    _this = _super.call(this);
    _this._groupId = void 0;
    _this._groupId = BmExpansionPanelLayout._groupCountUnique++;
    return _this;
  }

  (0, _createClass2.default)(BmExpansionPanelLayout, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changed) {
      if ((0, _get2.default)((0, _getPrototypeOf2.default)(BmExpansionPanelLayout.prototype), "shouldUpdate", this).call(this, changed)) {
        if (!this.info || !this.items) {
          return false;
        }

        this.setDefaultOptions();
        return true;
      }

      return false;
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmExpansionPanelLayout.prototype), "setDefaultOptions", this).call(this);
      this.info.options = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaultBmExpansionLayoutOpts), this.info.options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      BmExpansionPanelLayout._groupCountUnique++;
      var hideAdd = this.info.options.hideAdd;
      var hasPanels = this.info.options.order.length > 0;
      var panels = this.renderRows(this.info, this.items);
      var addBtn = (0, _element.guard)([hideAdd, hasPanels], function () {
        return (0, _element.cache)(hideAdd && hasPanels ? '' : _this2.renderAddPanelButton());
      });
      return this.html(_templateObject2(), panels, addBtn);
    }
  }, {
    key: "renderRows",
    value: function renderRows(info, items) {
      var _this3 = this;

      return (0, _repeatInstanceProperty(_element))(info.options.order, function (name) {
        return name;
      }, function (name, idx) {
        return (0, _element.guard)([_this3.items[name], idx], function () {
          return _this3.renderRow(items[name], idx);
        });
      });
    }
  }, {
    key: "renderRow",
    value: function renderRow(panelForm, panelIdx) {
      var firstPanel = panelIdx === 0;
      var _this$info$options = this.info.options,
          panelName = _this$info$options.rowName,
          autoClose = _this$info$options.autoClose,
          hideCaret = _this$info$options.hideCaret,
          disablePanelToggle = _this$info$options.disablePanelToggle;

      var _panelName = this.resolvePanelName(panelName, panelForm, panelIdx);

      var panelErrors = (0, _validators.getFormErrors)(panelForm);
      var valid = !panelErrors;
      return this.html(_templateObject3(), this._groupId, firstPanel, autoClose !== false && valid, hideCaret, Boolean(disablePanelToggle), _panelName, this.renderPanelContent(panelForm), this.renderPanelHeaderActions(panelIdx, panelForm.name));
    }
  }, {
    key: "renderPanelContent",
    value: function renderPanelContent(panelForm) {
      var _this4 = this;

      return (0, _element.guard)(panelForm, function () {
        return _this4.renderItem(panelForm);
      });
    }
  }, {
    key: "renderPanelHeaderActions",
    value: function renderPanelHeaderActions(idx, rowName) {
      var _hideRemove = this.shouldHideRemove(this.info.options.hideRemove, rowName);

      return this.html(_templateObject4(), _hideRemove ? null : this.renderRemovePanelButton(idx));
    }
  }, {
    key: "renderRemovePanelButton",
    value: function renderRemovePanelButton(idx) {
      var _this5 = this;

      return this.html(_templateObject5(), this.info.options.removeButtonLabel, function (evt) {
        return _this5.removeRow(evt, idx);
      });
    }
  }, {
    key: "renderAddPanelButton",
    value: function renderAddPanelButton() {
      var _this6 = this;

      var onAddRow = function onAddRow() {
        if (!_this6.info.options.hideAdd) {
          _this6.addRow();
        }
      };

      return this.html(_templateObject6(), this.info.options.addButtonLabel, onAddRow);
    }
  }, {
    key: "resolvePanelName",
    value: function resolvePanelName(panelName, item, idx) {
      var _context2;

      if (typeof panelName === 'string') {
        return panelName;
      }

      if (!panelName.resolved || !hasAllValues(panelName.resolved, item)) {
        var _context;

        return (0, _concat.default)(_context = "".concat(panelName.default, " (")).call(_context, idx + 1, ")");
      }

      return (0, _map.default)(_context2 = panelName.resolved).call(_context2, function (id) {
        return (0, _bmFormValues.getValue)(item.options.items[id]);
      }).join(' ');

      function hasAllValues(panelNameIds, item) {
        return (0, _every.default)(panelNameIds).call(panelNameIds, function (id) {
          var i = item.options.items[id];
          return (0, _bmFormValues.hasbmValuedFieldMixin)(i) && isDefined((0, _bmFormValues.getValue)(i));
        });
      }
    }
  }]);
  return BmExpansionPanelLayout;
}((0, _renderVariableLayout.bmVariableLayout)(_renderLayout.BmFormLayout));

BmExpansionPanelLayout._groupCountUnique = 0;

function isDefined(v) {
  return !(v === undefined || v === null || v === '');
}

var registerBmExpansionPanelLayout = function registerBmExpansionPanelLayout() {
  (0, _uiElements.registerBmExpansionPanel)();
  (0, _uiElements.registerBmExpansionPanelAddButton)();
  (0, _uiElements.registerBmExpansionPanelRemoveButton)();
  (0, _element.register)(BmExpansionPanelLayout);
  (0, _layoutRegistry.registerLayout)('expansion-panel', {
    renderer: renderBmExpansionPanelLayout,
    dependents: BmExpansionPanelLayout.dependents
  });
};

exports.registerBmExpansionPanelLayout = registerBmExpansionPanelLayout;

var renderBmExpansionPanelLayout = function renderBmExpansionPanelLayout(info, items) {
  return (0, _element.html)(_templateObject7(), info, items);
};

exports.renderBmExpansionPanelLayout = renderBmExpansionPanelLayout;
